export default "<p>report-course-tiles works!</p>\r\n";